import React, {useEffect, useRef} from 'react';
import {createPortal} from 'react-dom';
import s from './BurgerMenu.module.css';
import SidebarNavElements from '../Navigation/SidebarNavElements';

interface Props {
	burger: boolean;
	setBurger: (burger: boolean) => void;
}

const BurgerMenuNew: React.FC<Props> = ({burger, setBurger}) => {
	const scrollYRef = useRef<number>(0);

	// Блокировка скролла при открытии меню
	useEffect(() => {
		const body = document.body;
		const html = document.documentElement;

		if (burger) {
			// Сохраняем текущую позицию скролла
			scrollYRef.current = window.scrollY || window.pageYOffset;
			
			// Блокируем скролл
			body.style.position = 'fixed';
			body.style.top = `-${scrollYRef.current}px`;
			body.style.width = '100%';
			body.style.overflow = 'hidden';
			html.style.overflow = 'hidden';
		} else {
			// Восстанавливаем скролл
			body.style.position = '';
			body.style.top = '';
			body.style.width = '';
			body.style.overflow = '';
			html.style.overflow = '';
			
			// Восстанавливаем позицию скролла
			window.scrollTo(0, scrollYRef.current);
		}

		return () => {
			if (!burger) {
				body.style.position = '';
				body.style.top = '';
				body.style.width = '';
				body.style.overflow = '';
				html.style.overflow = '';
			}
		};
	}, [burger]);

	// Меню рендерится через портал в body, чтобы быть вне контекста хедера
	const menuBody = (
		<div className={`menu__body ${burger && 'active'}`}>
			<SidebarNavElements onMenuItemClick={() => setBurger(false)} />
		</div>
	);

	return (
		<div className={s.burgerMenuContainer}>
			<div
				role="button"
				tabIndex={0}
				className={`menu__icon ${burger && 'active'}`}
				onClick={() => setBurger(!burger)}
			>
				<span />
			</div>
			{burger && createPortal(menuBody, document.body)}
		</div>
	);
};

export default BurgerMenuNew;
